import { firebaseProjectId, functionsRegion } from './runtimeConfig.ts';

export interface HttpsFunctionUrlOptions {
  dev?: boolean;
}

const isDevelopmentRuntime = (): boolean => Boolean((import.meta as any).env?.DEV);

export const getHttpsFunctionUrl = (
  functionName: string,
  options: HttpsFunctionUrlOptions = {}
): string => {
  const isDevelopment = options.dev ?? isDevelopmentRuntime();

  if (isDevelopment) {
    return `http://127.0.0.1:5001/${firebaseProjectId}/${functionsRegion}/${functionName}`;
  }

  return `https://${functionsRegion}-${firebaseProjectId}.cloudfunctions.net/${functionName}`;
};

export const getReservationAnalyticsCollectorUrl = (options: HttpsFunctionUrlOptions = {}): string =>
  getHttpsFunctionUrl('collectReservationAnalyticsEvent', options);

export const getBookingFlowAnalyticsCollectorUrl = (options: HttpsFunctionUrlOptions = {}): string =>
  getHttpsFunctionUrl('collectBookingFlowAnalyticsEvent', options);

export const getBookingFlowAvailabilityUrl = (options: HttpsFunctionUrlOptions = {}): string =>
  getHttpsFunctionUrl('getBookingFlowAvailability', options);
